import React, { useState } from 'react';
import styled from 'styled-components';
import { CONTRAST } from '../theme';

/*
Usage:

// First define tabs
const TABS = [{
  id: BASIC,
  label: 'Basic',
  component: () => <h2>Basic</h2>,
}, {
  id: ADVANCED,
  label: 'Advanced',
  component: () => <h2>Advanced</h2>,
}];

// Define what happens on select (if anything)
const onSelect = (tabId) => console.log(tabId);

// Then pass TABS and onSelect into the component
<Tabs tabs={TABS} onSelect={onSelect} />
*/

const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Tab = styled.div`
  font-size: 16px;
  line-height: 1.3;
  padding: 16px 38px;
  color: ${CONTRAST};
  border-radius: 4px 4px 0 0;
  border-right: 1px solid #7e7e7e;
  border-top: 5px solid
    ${({ selected }) => (selected ? '#6BAED6' : 'transparent')};
  border-bottom: 1px solid
    ${({ selected }) => (!selected ? '#7E7E7E' : 'transparent')};
  cursor: pointer;
`;

const TabSpacer = styled.div`
  border-bottom: 1px solid #7e7e7e;
  flex: 1;
`;

const TabEl = styled.div`
  padding: 12px;
`;

export const Tabs = ({ tabs = [], initialState, additionalProps = {} }) => {
  const [selectedTab, setTab] = useState(initialState);
  const TabComponent = tabs.find(({ id }) => id === selectedTab).component;

  return (
    <div>
      <TabsContainer>
        {tabs.map(({ id, label }) => (
          <Tab
            key={id}
            selected={id === selectedTab}
            onClick={() => setTab(id)}
            additionalProps={additionalProps}
          >
            {label}
          </Tab>
        ))}
        <TabSpacer />
      </TabsContainer>
      <TabEl>
        <TabComponent additionalProps={additionalProps} />
      </TabEl>
    </div>
  );
};
